import { useSuspenseQuery } from "@tanstack/react-query";
import { createFileRoute } from "@tanstack/react-router";
import { Suspense } from "react";

import { AzureDevOpsConnectionsList } from "@/azure-devops/components/azure-devops-connections-list";
import { AzureDevOpsIssueRoutingCard } from "@/azure-devops/components/azure-devops-issue-routing-card";
import { useUserInfo } from "@/hooks/users/use-user-info";
import { useTRPC } from "@/infrastructure/trpc/react";
import { Skeleton } from "@/shared/ui/skeleton";
import { OrganizationRoles } from "@vivus/common";

export const Route = createFileRoute(
  "/app/organization/$id/settings/azure-devops"
)({
  loader: async ({ context, params }) => {
    await Promise.all([
      context.queryClient
        .query(
          context.trpc.azureDevOps.list.queryOptions({
            organizationId: params.id,
          })
        )
        .catch(() => undefined),
      context.queryClient
        .query(
          context.trpc.githubApp.getInstallation.queryOptions(
            {
              organizationId: params.id,
            }
          )
        )
        .catch(() => undefined),
    ]);
  },
  component: RouteComponent,
});

function RouteComponent() {
  const { id } = Route.useParams();
  const trpc = useTRPC();

  const { data: members } = useSuspenseQuery(
    trpc.organizationMember.getMembersByOrganizationId.queryOptions(
      {
        organizationId: id,
      }
    )
  );
  const { data: userInfo } = useUserInfo();
  const currentMember = members?.find(
    (m) => m.id === userInfo?.id
  );
  const canManage =
    currentMember?.role === OrganizationRoles.Owner ||
    currentMember?.role === OrganizationRoles.Admin;

  return (
    <Suspense
      fallback={
        <div className="space-y-4">
          <Skeleton className="h-8 w-48" />
          <Skeleton className="h-32 w-full" />
        </div>
      }
    >
      <div className="space-y-6">
        <AzureDevOpsIssueRoutingCard
          organizationId={id}
          canManage={canManage}
        />
        <AzureDevOpsConnectionsList
          organizationId={id}
          canManage={canManage}
        />
      </div>
    </Suspense>
  );
}
